import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dowload-modal',
  templateUrl: './dowload-modal.component.html',
  styleUrls: ['./dowload-modal.component.scss']
})
export class DowloadModalComponent implements OnInit {

  constructor(public readonly dialogRef: MatDialogRef<DowloadModalComponent>) {

  }

  ngOnInit() {
  }

  exit() {
    this.dialogRef.close();
  }

  download() {
    this.dialogRef.close({ status: true });
  }
}
